<template>
  <base-layout>
  <template v-slot:header>
    <app-header/>
  </template>

  <template v-slot:banner>
    <HomeBanner/>
  </template>
  <template v-slot:default>
   <ProductList/>
  </template>

  <template v-slot:footer>
   <app-footer/>

  </template>
</base-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import ProductList from '@/components/ProductList'
import HomeBanner from '@/components/HomeBanner'
import BaseLayout from '@/layout/BaseLayout'
import Carousel from '@/components/Carousel'

export default {
  components: {
    BaseLayout,
    AppHeader,
    ProductList,
    HomeBanner,
    Carousel,
    AppFooter
  },
  mounted () {
    // this.showToast()
    window.analytics.page('Home')
  },
  data () {
    return {
      count: 0
    }
  },
  methods: {
    showToast () {
      const h = this.$createElement
      let randomNames = [
        {name: 'Samuel', location: 'Berlin, DE'},
        {name: 'Charlie', location: 'Fareham, UK'},
        {name: 'Amy', location: 'Burnsville, US'},
        {name: 'Leticia', location: 'Coachella, US'},
        {name: 'Carolina', location: 'Hollywood, US'},
        {name: 'Jordyn', location: 'Washington, US'},
        {name: 'Florence ', location: 'Ashley, DE'}
      ]
      // Increment the toast count
      this.count++
      // Create the message
      this.intervalToast = setInterval(function () {
        let customer = randomNames[Math.floor(Math.random() * randomNames.length)]
        const vNodesMsg = h(
          'p',
          { class: ['text-center', 'mb-0'] },
          [
            h('b-spinner', { props: { type: 'grow', small: true } }),
            ` ${customer.name} from ${customer.location} just bought 4 SanitizerWristbands ${Math.floor(Math.random() * 20)} minutes ago `,
            h('b-spinner', { props: { type: 'grow', small: true } })
          ]
        )
        this.$bvToast.toast([vNodesMsg], {
          // title: [vNodesTitle],
          toaster: 'b-toaster-bottom-left',
          solid: true,
          variant: 'info',
          autoHideDelay: 4500
        })
      }.bind(this), 10000)
    }
  }
}
</script>
<style>
 .clickable {
   cursor:pointer
 }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue